export const DesktopNavigation = ({ scrollToSection }) => (
<div className="hidden lg:flex items-center space-x-6">
              <button data-testid="desktop-nav-services" onClick={() => scrollToSection('services')} className="text-white hover:text-yellow-400 transition-colors font-medium">
                Services
              </button>
              <button data-testid="desktop-nav-testimonials" onClick={() => scrollToSection('temoignages')} className="text-white hover:text-yellow-400 transition-colors font-medium">
                Témoignages
              </button>
              <button data-testid="desktop-nav-cities" onClick={() => scrollToSection('villes')} className="text-white hover:text-yellow-400 transition-colors font-medium">
                Villes
              </button>
              <button data-testid="desktop-nav-contact" onClick={() => scrollToSection('contact')} className="text-white hover:text-yellow-400 transition-colors font-medium">
                Contact
              </button>
            </div>
);
